/**
 * 得到向量 ba bc 的夹角。
 * @param pointx ax bx cx
 * @param pointy ay by cy
 * @returns {number} 返回角度
 */
export function getAngleByThreePoint (pointx: number[], pointy: number[]) {
  let a_b_x = pointx[0] - pointx[1];
  let a_b_y = pointy[0] - pointy[1];
  let c_b_x = pointx[2] - pointx[1];
  let c_b_y = pointy[2] - pointy[1];
  let ab_mul_cb = a_b_x * c_b_x + a_b_y * c_b_y;
  let dist_ab = Math.sqrt(a_b_x * a_b_x + a_b_y * a_b_y);
  let dist_cd = Math.sqrt(c_b_x * c_b_x + c_b_y * c_b_y);
  let cosValue = ab_mul_cb / (dist_ab * dist_cd);
  return Number(((Math.acos(cosValue) * 180) / Math.PI).toFixed(6));
}
